import React from "react";
import { Image as ImageIcon } from "@phosphor-icons/react";
import { API } from "@/lib/api";

export const RAINBOW_BG =
  "conic-gradient(from 0deg, #ff0000, #ff8a00, #ffe600, #00c853, #00b0ff, #7c4dff, #ff00c8, #ff0000)";

export const CARBON_BG = {
  backgroundColor: "#1a1a1a",
  backgroundImage:
    "repeating-linear-gradient(45deg, #2b2b2b 0, #2b2b2b 2px, #111 2px, #111 4px), repeating-linear-gradient(-45deg, #2b2b2b 0, #2b2b2b 2px, #111 2px, #111 4px)",
};

export function ColorSwatch({ color, size = 20, className = "" }) {
  const base = `rounded-full border border-gray-400 shrink-0 ${className}`;
  const style = { width: size, height: size };
  if (color?.special === "rainbow") return <span className={base} style={{ ...style, background: RAINBOW_BG }} />;
  if (color?.special === "carbon") return <span className={base} style={{ ...style, ...CARBON_BG }} />;
  if (color?.image_path) return <img src={`${API}/files/${color.image_path}`} alt={color?.name || ""} className={`object-cover ${base}`} style={style} />;
  return <span className={base} style={{ ...style, background: color?.hex || "#ddd" }} />;
}

export function MotifThumb({ motif, size = 20, className = "" }) {
  const base = `rounded border border-gray-400 shrink-0 flex items-center justify-center bg-gray-50 ${className}`;
  const style = { width: size, height: size };
  if (motif?.image_path) return <img src={`${API}/files/${motif.image_path}`} alt={motif?.name || ""} className={`object-cover ${base}`} style={style} />;
  return <span className={base} style={style}><ImageIcon size={Math.round(size * 0.6)} className="text-gray-300" /></span>;
}
